<template>
  <el-button
    :loading="loading"
    :disabled="disabled"
    type="success"
    @click="hascombineddelivery">
    <span>批量建单发货</span>
    <span v-if="showCount">(共{{ selection.length }}项)</span>
    <el-dialog
      title="以下发货单可合并发货"
      :visible.sync="visible"
      width="960px"
      append-to-body>
      <el-table
        border=""
        :data="list">
        <el-table-column
          label="发货单号"
          :resizable="false"
          min-width="150"
          prop="outOrderCode">
          <template slot-scope="{row}">
            <span v-if="row.createTime">{{ row.outOrderCode }}</span>
            <span
              v-else
              style="color: #f56c6c;">[待创建]</span>
          </template>
        </el-table-column>
        <el-table-column
          label="订单号"
          :resizable="false"
          min-width="150"
          prop="salesOrderCode">
        </el-table-column>
        <el-table-column
          label="收件人"
          :resizable="false"
          min-width="300"
          prop="receiverName">
          <template slot-scope="{row}">
            {{ row.receiverName }}-<span v-if="row.receiverMobile">{{ row.receiverMobile }}</span><span v-if="row.receiverTel">{{ row.receiverTel }}</span>
            <div>{{ row.receiverProvince }}{{ row.receiverCity }}{{ row.receiverDistrict }}{{ row.receiverAddress }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="仓库"
          :resizable="false"
          min-width="120"
          prop="warehouseNo">
          <template slot-scope="{row}"> {{ row.warehouseNo | warehouseName() }}</template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          :resizable="false"
          width="150">
          <template slot-scope="{row}">
            {{ row.createTime | dateformat( ) }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="订单来源"
          width="110"
          :resizable="false">
          <template slot-scope="{row}">
            {{ row.source | sourceName() }}
          </template>
        </el-table-column>
        -->
      </el-table>
      <el-alert
        style="margin-top: 10px"
        :closable="false"
        title="发货单号为空的单据说明：本次勾选的订单中，可合并发货的订单对应的发货单（提交后生成）。"
        type="warning">
      </el-alert>
      <div slot="footer">
        <div style="font-size: 13px;color: #606266;margin-right: 20px;text-align:left">
          本次勾选订单：<span style="color:#409EFF;font-size: 14px;">{{ selection.length }}</span>单，可合并发货单：<span style="color:#409EFF;font-size: 14px;">{{ list.length }}</span>单
        </div>
        <el-button
          :loading="loading"
          @click="batchOut(false)">不合并建单</el-button>
        <el-button
          type="primary"
          :loading="loading"
          @click="batchOut(true)">合并建单</el-button>
      </div>
    </el-dialog>
  </el-button>
</template>

<script>

function noop() {}
export default {
  name: 'BatchOutOrderBtn',
  props: {
    callback: {
      type: Function,
      default: noop
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showCount: {
      type: Boolean,
      default: false
    },
    selection: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      list: []
    }
  },
  methods: {
    hascombineddelivery() {
      if (this.selection.length === 0) {
        this.$message.error('请先勾选订单')
        return
      }
      this.loading = true
      this.$emit('toggleLoading', true)
      this.$store.dispatch('outstock/hascombineddelivery', {
        payload: {
          salesOrderIdList: this.selection.map(i => i.id)
        },
        success: (res) => {
          this.loading = false
          this.$emit('toggleLoading', false)
          this.list = res.data.data || []
          if (this.list.length > 0) {
            this.visible = true
          } else {
            this.addbysalesorder(false)
          }
        },
        fail: () => {
          this.list = []
          this.$emit('toggleLoading', false)
          this.loading = false
        }
      })
    },
    batchOut(combinedDelivery) {
      if (this.selection.length === 0) {
        this.$message.error('请先勾选订单')
        return
      }
      this.$confirm(`此操作将${combinedDelivery ? '会' : '不会'}对选中的订单进行合并建单发货, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.addbysalesorder(combinedDelivery)
      })
    },
    addbysalesorder(combinedDelivery) {
      this.loading = true
      this.$emit('toggleLoading', true)
      this.$store.dispatch('outstock/addbysalesorder', {
        payload: {
          combinedDelivery,
          salesOrderIdList: this.selection.map(i => i.id)
        },
        success: (res) => {
          this.loading = false
          this.$emit('toggleLoading', false)
          this.visible = false
          if (res.data.data && res.data.data.length > 0) {
            this.$alert(`批量建单请求订单数为${this.multipleSelection.length}单，其中${res.data.data.length}单由于库存不足建单失败！`, '提示', {
              confirmButtonText: '确定'
            })
          }
          this.callback && this.callback()
        },
        fail: () => {
          this.loading = false
          this.$emit('toggleLoading', false)
        }
      })
    }
  }
}
</script>
